export const supportedPlatforms = {
  ios: 'ios',
  macos: 'macos',
  visionos: 'visionos',
  tvos: 'tvos',
} as const;
